import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

const EditInstallment = ({ installment, onClose }) => {
  const [installmentName, setInstallmentName] = useState(
    installment.installmentName
  );
  const [installmentNumber, setInstallmentNumber] = useState(
    installment.installmentNumber
  );
  const [errors, setErrors] = useState({});
  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!installmentName) {
      newErrors.installmentName = "Installment name is required";
    }
    if (!installmentNumber) {
      newErrors.installmentNumber = "Installment number is required";
    } else if (installmentNumber.length !== 2) {
      newErrors.installmentNumber =
        "Installment number must be 2 characters long";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }

    const formData = { installmentName, installmentNumber };

    try {
      const response = await fetch(
        `${Api}/api/installment/${installment._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const result = await response.json();
        toast.success("Updated Successfully");
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error updating form:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating form:", error);
    }
  };

  return (
    <div className="stateForm">
      <Modal show onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Installment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formInstallmentName">
              <Form.Label>Installment Name</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter Installment Name"
                  value={installmentName}
                  onChange={(e) => setInstallmentName(e.target.value)}
                  isInvalid={!!errors.installmentName}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.installmentName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formInstallmentNumber">
              <Form.Label>Installment Number</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter Installment Number"
                  value={installmentNumber}
                  onChange={(e) => setInstallmentNumber(e.target.value)}
                  isInvalid={!!errors.installmentNumber}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.installmentNumber}
              </Form.Control.Feedback>
            </Form.Group>

            <button
              type="submit"
              className="btn btn-outline-primary btn-icon-text mt-3"
            >
              <i className="mdi mdi-file-check btn-icon-prepend"></i>
              Submit
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditInstallment;
